const AUTOPLAY_BUTTON_PAUSE_LABEL = "Pause";
const AUTOPLAY_BUTTON_PLAY_LABEL = "Play";
const COMPONENT_NAME = "Carousel";
const DEFAULT_DELAY_MS = 8 * 1e3;
const DEFAULT_MAX_ITEMS_PER_SLIDE = {
  desktop: 5,
  tablet: 3,
  mobile: 2
};
export {
  AUTOPLAY_BUTTON_PAUSE_LABEL,
  AUTOPLAY_BUTTON_PLAY_LABEL,
  COMPONENT_NAME,
  DEFAULT_DELAY_MS,
  DEFAULT_MAX_ITEMS_PER_SLIDE
};
